/* Generated by scripts/buildItemAtlas.mjs. Do not edit by hand. */
export const ITEM_ATLAS_URL = "/items/item-atlas.webp";
export const ITEM_ATLAS_COLUMNS = 8;
export const ITEM_ATLAS_ROWS = 7;
export const ITEM_ATLAS_COORDS: Readonly<Record<string, readonly [number, number, number, number]>> = {
  "ammo_12g_buck": [0.08984375, 0.04296875, 0.69140625, 0.8671875],
  "ammo_12g_slug": [1.26953125, 0, 0.45703125, 1],
  "ammo_762_fmj": [2.1484375, 0.01171875, 0.8125, 0.984375],
  "ammo_762_hp": [3.1875, 0.0390625, 0.70703125, 0.9296875],
  "ammo_8x57_fmj": [4.16796875, 0, 0.8125, 1],
  "ammo_8x57_sp": [5.14453125, 0, 0.74609375, 0.984375],
  "ammo_9x19_fmj": [6.19140625, 0.01953125, 0.78515625, 0.953125],
  "ammo_9x19_hp": [7.05859375, 0.12109375, 0.87890625, 0.7421875],
  "ammobox": [0.01171875, 1.0703125, 0.98046875, 0.8671875],
  "batterie": [1.34765625, 1.0625, 0.296875, 0.875],
  "benzinkanister": [2.17578125, 1.02734375, 0.64453125, 0.94140625],
  "bergkaese": [3, 1.078125, 1, 0.83984375],
  "carbine": [4.046875, 1.36328125, 0.953125, 0.23828125],
  "dmr": [5.0546875, 1.2734375, 0.90625, 0.31640625],
  "euro": [6, 1.05859375, 1, 0.89453125],
  "feuerzeug": [7.0859375, 1.01953125, 0.75390625, 0.94921875],
  "gamsbart": [0.0546875, 2.0234375, 0.88671875, 0.9609375],
  "gamskrickel": [1.01171875, 2.01171875, 0.9765625, 0.9765625],
  "graggy_obstler": [2.16015625, 2, 0.671875, 1],
  "gren_flash": [3.01171875, 2.01171875, 0.9765625, 0.9765625],
  "gren_frag": [4.01171875, 2.01171875, 0.9765625, 0.9765625],
  "gren_smoke": [5.01171875, 2.01171875, 0.9765625, 0.9765625],
  "helmet_gendarm": [6.0546875, 2.03125, 0.88671875, 0.9375],
  "helmet_stahl": [7.01171875, 2.03515625, 0.9765625, 0.9296875],
  "honigglas": [0.07421875, 3.015625, 0.85546875, 0.97265625],
  "jagdmesser": [1, 3.03125, 1, 0.94140625],
  "junkbox": [2.015625, 3.11328125, 0.96484375, 0.81640625],
  "kupferdraht": [3.015625, 3.10546875, 0.96484375, 0.7890625],
  "meat_hare": [4.01171875, 3.01171875, 0.9765625, 0.9765625],
  "meat_venison": [5.01171875, 3.23828125, 0.9765625, 0.5234375],
  "med_erstehilfe": [6.03125, 3.03125, 0.92578125, 0.91796875],
  "med_sanikasten": [7.05859375, 3.05078125, 0.90234375, 0.91015625],
  "med_schiene": [0, 4.0625, 1, 0.8828125],
  "med_verband": [1.046875, 4.06640625, 0.90234375, 0.82421875],
  "medbox": [2, 4.0625, 1, 0.86328125],
  "naegel": [3.03515625, 4.01171875, 0.95703125, 0.96875],
  "pack_expedition": [4.11328125, 4, 0.7890625, 1],
  "pack_jagd": [5.046875, 4, 0.87109375, 1],
  "pack_tourer": [6.17578125, 4, 0.65625, 1],
  "pack_wander": [7.18359375, 4.12109375, 0.62109375, 0.734375],
  "pistol": [0.02734375, 5.08203125, 0.9453125, 0.828125],
  "rig_brustgurt": [1, 5.06640625, 1, 0.859375],
  "rig_patronengurt": [2, 5.06640625, 1, 0.859375],
  "schnaps": [3.18359375, 5, 0.6328125, 1],
  "schraubenzieher": [4.0234375, 5, 0.9765625, 1],
  "shotgun": [5.03515625, 5.31640625, 0.953125, 0.28515625],
  "silberkreuz": [6.18359375, 5, 0.65625, 1],
  "smg": [7, 5.11328125, 0.984375, 0.84765625],
  "speck": [0, 6.08984375, 1, 0.88671875],
  "streichhoelzer": [1.01953125, 6.05859375, 0.98046875, 0.90625],
  "taschenuhr": [2.01171875, 6, 0.93359375, 1],
  "vest_gendarm": [3.109375, 6.02734375, 0.78125, 0.9375],
  "vest_loden": [4.125, 6, 0.73828125, 1],
  "vest_platte": [5.0703125, 6, 0.85546875, 0.9921875],
  "zigaretten": [6.21484375, 6, 0.6875, 1],
  "zuendkerzen": [7.0703125, 6.0390625, 0.875, 0.90625],
};

export const TRADER_PLACEHOLDER_URL = "/traders/placeholder.svg";
export const TRADER_PORTRAIT_URLS: Readonly<Record<string, string>> = {
  "el-gato": "/traders/el-gato.png",
  "graggy": "/traders/graggy.png",
};
